/*** Odd for 1x2(4,11) , ML(12,13) **/
"use strict";

import Vue from 'vue'
import VueFilterNumber from '@/vue/filters/vue-filter-number'
import allBetMixin from '@/vue/mixins/allBet'
import EventBus from '@/vue/events/event-bus'
import minibet from '@/vue/components/mini-bet'

import {
  mapGetters,
} from 'vuex'

Vue.component('odd1x2', {
  components: {
    minibet,
  },
  computed: {
    ...mapGetters([
      'sportMiniBet',
      'changeOdds',
      'isChangeTemplate',
      'ShowUpDown',
    ]),
    betForm() {
      return this.$store.getters.betForm[0]
    },
  },
  mixins: [allBetMixin],
  name: 'odd1x2',
  template: `
    <div :id="getOddUniqueId(event)" class="odds od2" :class="[getOdCls(mode,betType,event), getClass(event, isNegative, isDiff, isUp, isClosePause)]" @click="onClickOdd($event);">
      <div  v-if="mode=='ab'||mode=='simple'" :style="(betType >= 59 && betType <= 73) ? 'padding: 17px 45%;' : (mode=='ab')? 'padding:45%;' : 'padding:50%;'" :title=" getTitle(event.tacapt, event.tbcapt, team) "></div>
        <template v-if="event.od[plyType]">
          <template v-if="event.od[plyType][betType]">
            <template v-if="event.od[plyType][betType]['odds'+team]">
              <template v-if="sportMiniBet.allow && sportMiniBet.toggle && checkMiniBetUnique(event, getOddUniqueId(event))">
                <span>{{ getDecimalDisplay(betForm.odd) }}</span>
              </template>
              <template v-else>
                <template v-if="mode=='ab'">
                  <div class="">
                    <span class="yb-family-odds yb-number-bold match_details"> <!-- up/down : odds updown-->
                    {{ getDecimalDisplay(event.od[plyType][betType]['odds'+team]) }}
                    </span>
                  </div>
                </template>
                <template v-else>
                  <span>{{ getDecimalDisplay(event.od[plyType][betType]['odds'+team]) }}</span>
                  <div class="odds-arrows-wrap">
                    <div class="odds-icon odds-up"></div>
                    <div class="odds-icon odds-down"></div>
                  </div>
                </template>
              </template>
            </template>
            <template v-else-if="event.od[plyType][betType]['a']">
              <template v-if="event.od[plyType][betType]['a']['odds'+team]">
                <template v-if="sportMiniBet.allow && sportMiniBet.toggle && checkMiniBetUnique(event, getOddUniqueId(event))">
                  <span>{{ getDecimalDisplay(betForm.odd) }}</span>
                </template>
                <template v-else>
                  <template v-if="mode=='ab'">
                    <div class="">
                      <span class="yb-family-odds yb-number-bold match_details"> <!-- up/down : odds updown-->
                        {{ getDecimalDisplay(event.od[plyType][betType]['a']['odds'+team]) }}
                      </span>
                    </div>
                  </template>
                  <template v-else>
                    <span>{{ getDecimalDisplay(event.od[plyType][betType]['a']['odds'+team]) }}</span>
                    <div class="odds-arrows-wrap">
                      <div class="odds-icon odds-up"></div>
                      <div class="odds-icon odds-down"></div>
                    </div>
                  </template>
                </template>
              </template>
              <template v-else>
                <div class="lock m-icon"></div>
              </template>
            </template>
            <template v-else>
              <div class="lock m-icon" style="margin: auto;"></div>
            </template>
          </template>
          <template v-else>
            <div class="lock m-icon"  style="margin: auto;"></div>
          </template>
        </template>
        <template v-else>
          <div class="lock m-icon"  style="margin: auto;"></div>
        </template>
      </template>
    </div>
  `,
  // <div>
  //     <template v-if="event.od">
  //       <template v-if="event.od[plyType]">
  //         <template v-if="event.od[plyType][betType]">
  //           <template v-if="event.od[plyType][betType]['odds'+team]">
  //             <div class="oddsBet" :class="getClass(event, isNegative, isDiff, isUp)" @click="onClickOdd($event);">
  //               <span :class="getOddUniqueClass(event)">
  //                 <template v-if="sportMiniBet.allow && sportMiniBet.toggle && checkMiniBetUnique(event, getOddUniqueId(event))">
  //                   {{ getDecimalDisplay(betForm.odd) }}
  //                 </template>
  //                 <template v-else>
  //                   {{ getDecimalDisplay(event.od[plyType][betType]['odds'+team]) }}
  //                 </template>
  //               </span>
  //               <minibet v-if="sportMiniBet.allow && sportMiniBet.toggle && checkMiniBetUnique(event, getOddUniqueId(event))"></minibet>
  //             </div>
  //           </template>
  //           <template v-else>
  //             <div class="icon-lock"></div>
  //           </template>
  //         </template>
  //         <template v-else>
  //           <div class="icon-lock"></div>
  //         </template>
  //       </template>
  //       <template v-else>
  //         <div class="icon-lock"></div>
  //       </template>
  //     </template>
  //   </div>
  props: {
    event: null,
    team: null,
    plyType: null,
    betType: null,
    mode: null,
  },
  watch: {
    'event': {
      handler(val, oldVal) {
        if (this.isDefinedOdds(val)) {
          if(this.betType >= 59 && this.betType <= 73){
            this.classNegative(val.od[this.plyType][this.betType]['a']['odds' + this.team])  
          }else{
            this.classNegative(val.od[this.plyType][this.betType]['odds' + this.team])
          }
          //check if immediate call
          // if (oldVal && !this.refreshOdd) {
          if (oldVal && !this.isChangeTemplate) {
            this.refreshOdd = false
            if (this.isDefinedOdds(oldVal)) {
              if(this.betType >= 59 && this.betType <= 73){
                this.diffOddsUpDown(val.od[this.plyType][this.betType]['a']['odds' + this.team], oldVal.od[this.plyType][this.betType]['a']['odds' + this.team])
                this.diffOdds(val.od[this.plyType][this.betType]['a']['odds' + this.team], oldVal.od[this.plyType][this.betType]['a']['odds' + this.team])
              }else{
                this.diffOddsUpDown(val.od[this.plyType][this.betType]['odds' + this.team], oldVal.od[this.plyType][this.betType]['odds' + this.team])
                this.diffOdds(val.od[this.plyType][this.betType]['odds' + this.team], oldVal.od[this.plyType][this.betType]['odds' + this.team])
              }
            }
          } else if (this.refreshOdd) {
            this.refreshOdd = false
            this.isDiff = false
          } else if (!oldVal) { //when not same template
            this.refreshOdd = true
          }
        } else {
          this.isClosePause = true
        }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      isNegative: false,
      isDiff: false,
      isUp: false,
      isClosePause: false,
      matchId: null,
      refreshOdd: false,
    }
  },
  methods: {
    getOdCls(mode, bt, event) {
      var a = ' odds-default'
      if (mode == 'ab') {
        a += ' odds-ou yb-number-font'
        a += ' odds-sc'
        if(bt=='4' || bt=='11' || bt=='12' || bt=='13'){
          a += ' ab-right'
        }
      } else {
        if(jQuery.inArray(bt, ['4','11','3','9','7','16','46','47','48','49','32','33','38','39','34','35','30','31']) != '-1'){
          //Handle odds at common with hdp/text on right of odds
          a += ' c-right'
        } else if(bt=='12' || bt=='13'){
          a += ' c-center'
        }
      }
      // style="position: absolute;inset: 0px;margin-right: 10px;" :style="{ 'justify-content': mode=='ab'&& betType!=4 && betType==1 ? 'center': 'right'}"
      return a
    },
    getTitle(Ta, Tb, team){
      if(this.betType == '65' || this.betType == '66'){
        if(this.team == 'ha') { 
          return this.event.tacapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES']
        } else if (this.team == 'hb') {
          return this.event.tacapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO']
        } else if (this.team == 'da') { 
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES']
        } else if (this.team == 'db') { 
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO']
        } else if (this.team == 'aa') { 
          return this.event.tbcapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES']
        } else { 
          return this.event.tbcapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO']
        }
      } else if(this.betType == '67' || this.betType == '68'){
        if(this.team == 'ha') { 
          return this.event.tacapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tacapt
        } else if (this.team == 'hb') {
          return this.event.tacapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tbcapt
        } else if (this.team == 'da') { 
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tacapt
        } else if (this.team == 'db') { 
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tbcapt
        } else if (this.team == 'aa') { 
          return this.event.tbcapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tacapt
        } else { 
          return this.event.tbcapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tbcapt
        }
      } else if (this.betType == this.h1x2BetType || this.betType == this.rh1x2BetType){
        if(team == 'h'){
          return Ta
        }else if(team == 'a'){
          return Tb
        } else {
          var hdp = this.event.od[this.plyType][this.betType]['hdp']
          if(hdp > 0){
            return this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW']
          } else {
            var newHdp = (parseInt(hdp) * -1)
            var awayHdp = ''

            if (newHdp > 0) {
              awayHdp = '+' + newHdp
            } else if (newHdp < 0) {
              awayHdp = newHdp
            }
            return this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW']+' '+this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY']+' '+awayHdp
          }
        }
      }

      var title = ''
      if(team == 'h'){
        title = Ta
      }else if(team == 'a'){
        title = Tb
      }
      const parser = new DOMParser();
      return parser.parseFromString(title, "text/html").body.textContent;
      // return title
    },
    getClass(event, isNeg, isDif, isUp, isClosePause) {
      var classStr = ''
      var classMini = ''

      if(this.changeOdds && this.ShowUpDown == true){
        if (this.refreshOdd && isDif) {
          classStr = 'indicator'  //indicatorUp
        }
      } else if (isClosePause) {
        classStr = ''
      } else {
        if (!this.isChangeTemplate && isDif && this.ShowUpDown == true) {  //refresh
          if(isUp){
            classStr = 'up'
            // classStr = 'indicatorUp'
          } else {
            classStr = 'down'
            // classStr = 'indicatorDown'
          }
        }
      }

      return classStr + classMini
    },
    getOddUniqueClass(event) {
      var classStr = ''

      if (this.isNegative) {
        classStr += 'ngve '
      }

      if (this.isDiff) {
        classStr += 'diff '
      }

      classStr += this.getOddUniqueId(event)
      return classStr
    },
    getUniqueMID(event){
      return event.eveid + this.plyType + this.betType + this.team  //1x2 only a
    },
    getOddUniqueId(event) {
      return event.eveid + this.plyType + this.betType + this.team
    },
    onClickOdd(windowEvent) {
      EventBus.$emit('returnBetTab')
      if (this.account.previewFlag && window._hasRedirect) {
        $('.login-redirect-dialog').show();
        return
      }
      if(this.event.od[this.plyType][this.betType] == undefined){
        return
      }else if ((this.betType >= 59 && this.betType <= 73) && this.event.od[this.plyType][this.betType]['a']['odds' + this.team]<=0){
        return
      }else if((this.$store.getters.account.oddsType != 'in' && this.$store.getters.account.oddsType != 'my' && this.$store.getters.account.oddsType != 'am') && this.event.od[this.plyType][this.betType]['odds' + this.team]<=0){
        return
      }

      if (!this.account.previewFlag) {
        var _hdp = '0'
        if(this.betType=='21' || this.betType=='27'){ //H1x3(3way)
          _hdp = this.event.od[this.plyType][this.betType]['hdp']
        }
        var od = ''

        if(this.betType == '65' || this.betType == '66'){
          od = this.event.od[this.plyType][this.betType]['a']['odds' + this.team]
        }else{
          od = this.event.od[this.plyType][this.betType]['odds' + this.team]
        }

        var betForm = {
          title: this.$store.getters.selectedBettype.sprtTitleLang,
          eveid: this.event.eveid,
          league: this.event.lgecapt,
          sprtid: this.event.sptid,
          plyType: this.plyType,
          betType: this.betType,
          ta: this.event.tacapt,
          tb: this.event.tbcapt,
          taid: this.event.taid,
          tbid: this.event.tbid,
          odd: od,
          rbscoa: 0,
          rbscob: 0,
          hdp: _hdp,
          // hdp: '0',
          dual: 'a', //1x2 only a
          fav: '0',
          uniqueId: this.event.eveid + this.plyType + this.betType + this.team,
          eventObj: this.event,
        }
        
        if (this.event.rb) {
          if (this.event.rbinfo) {
            betForm.rbscoa = this.event.rbinfo.scoa
            betForm.rbscob = this.event.rbinfo.scob
          }
        }

        if(this.betType == '65' || this.betType == '66'){
          if(this.team == 'ha') { 
            betForm.tbetcapt = this.event.tacapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES']
            betForm.tbetid = 'ha'
            betForm.tbet = 'ha'
          } else if (this.team == 'hb') {
            betForm.tbetcapt = this.event.tacapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO']
            betForm.tbetid = 'hb'
            betForm.tbet = 'hb'
          } else if (this.team == 'da') { 
            betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES']
            betForm.tbetid = 'da'
            betForm.tbet = 'da'
          } else if (this.team == 'db') { 
            betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO']
            betForm.tbetid = 'db'
            betForm.tbet = 'db'
          } else if (this.team == 'aa') { 
            betForm.tbetcapt = this.event.tbcapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES']
            betForm.tbetid = 'aa'
            betForm.tbet = 'aa'
          } else { 
            betForm.tbetcapt = this.event.tbcapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO']
            betForm.tbetid = 'ab'
            betForm.tbet = 'ab'
          }
        }else if(this.betType == '67' || this.betType == '68'){
          if(this.team == 'ha') { 
            betForm.tbetcapt = this.event.tacapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tacapt
            betForm.tbetid = 'ha'
            betForm.tbet = 'ha'
          } else if (this.team == 'hb') {
            betForm.tbetcapt = this.event.tacapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tbcapt
            betForm.tbetid = 'hb'
            betForm.tbet = 'hb'
          } else if (this.team == 'da') { 
            betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tacapt
            betForm.tbetid = 'da'
            betForm.tbet = 'da'
          } else if (this.team == 'db') { 
            betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tbcapt
            betForm.tbetid = 'db'
            betForm.tbet = 'db'
          } else if (this.team == 'aa') { 
            betForm.tbetcapt = this.event.tbcapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tacapt
            betForm.tbetid = 'aa'
            betForm.tbet = 'aa'
          } else { 
            betForm.tbetcapt = this.event.tbcapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tbcapt
            betForm.tbetid = 'ab'
            betForm.tbet = 'ab'
          }
        }else{
          if (this.team == 'd') { //is bet draw
            betForm.tbetcapt = this.$store.getters.sportTableLang.table['SPORT_TABLE.DRAW']
            betForm.tbetid = 'x'
            betForm.tbet = 'x'
          } else if (this.team == 'h') { //is bet team a
            betForm.tbetcapt = this.event.tacapt
            betForm.tbetid = this.event['taid']
            betForm.tbet = 'a'
          } else { //is bet team b
            betForm.tbetcapt = this.event.tbcapt
            betForm.tbetid = this.event['tbid']
            betForm.tbet = 'b'
          }
        }

        if (this.$store.getters.selectedMarket == this.$store.getters.market.inPlayMarket.key) {
          var market = this.$store.getters.market.inPlayMarket
          betForm.plytypcapt = '(' + market.betLang + ') ' + this.plyType
        } else if (this.$store.getters.selectedMarket == this.$store.getters.market.earlyMarket.key) {
          // betForm.title = this.$store.getters.selectedBettype.sprtTitleLang + ' - ' + this.$store.getters.market.earlyMarket.betLang
        }

        // Check if current sel has selected, if true remove else add
        var indexx = _.findIndex(this.$store.getters.betForm, {
          'eveid': this.event.eveid,
          'plyType': this.plyType,
          'betType': this.betType,
          'tbet': betForm.tbet,
        });
        if(indexx > -1){
          var obj = {eveid: this.event.eveid}
          if(this.$store.getters.isBetCombo){
            obj = {clearType: '3', index: indexx}
          }
          this.$store.commit("BETCOMBO_AMOUNT", { spliceIndex: true, index: indexx });
          this.$store.commit("BETCOMBO_KEYBOARDALLOW", { spliceIndex: true, index: indexx });

          this.$store.dispatch("removeMatch", {
            // eveid: this.event.eveid,
            data: obj,
            callback: (() => {
              this.$store.commit("PARLAY_SELECTED", {
                remove: true,
                eveid: this.event.eveid,
              });
              var MID = $(windowEvent.target).closest('div[id]')[0].id
              // document.getElementById(MID).parentElement.classList.remove('active')
              $("[id="+MID+"]").closest('.c-bet-item.active').removeClass('active')
              if (this.$store.getters.betForm.length <= 0) {
                
                this.$store.commit("OPEN_BETFORM", false)
                this.$store.commit('ODD_SELECTED', false)
                this.$store.commit("SHOW_BETFORM_MENU", false);
                this.$store.commit('SELECTED_TAB', 'betTab')
                return;
              } else {
                this.$store.commit('OPEN_BETFORM', true)
              }
              this.$store.dispatch("getBettingInfo", {
                callback: ((res) => {
                  this.$store.commit("SPORT_MAPPING_BETTING", {
                    newBettingList: res.SYSTEM_DATA.betting,
                    oldBettingList: this.$store.getters.betForm,
                  });
                  // this.refreshTimer();
                  // this.isReloading = false;
                }).bind(this),
              });
            }).bind(this),
          });
        } else {
          //betcombo validate max betcombo wager
          if(this.$store.getters.isBetCombo && this.$store.getters.betForm.length==this.betComboMax){
            var chkRes = this.checkBetComboMax(betForm)
            if(chkRes){
              return
            }
          }
          // parlay
          if(this.$store.getters.selectedBettype.betTypId == '5' && this.$store.getters.betting.minMax!=undefined && this.$store.getters.betting.minMax.maxCombo!=undefined){
            if(this.$store.getters.betForm.length==this.$store.getters.betting.minMax.maxCombo){
              let vue = this
              let maxMulpComboMsg = this.$store.getters.betLang['BETTING.HIT_MAX_COMBO']
              this.$store.commit('DIALOG_TOGGLE',{
                show: true,
                msg: maxMulpComboMsg
              })
              // this.$store.commit('JS_ERR', {error:true, msg:maxMulpComboMsg})
              setTimeout(function() {
                // vue.$store.commit('JS_ERR', {error:false})
                vue.$store.commit('DIALOG_TOGGLE', {reset:true})
              }, 5000);
              return
            }
          }

          this.$store.dispatch('getLatestInfo', {
            data: betForm,
            callback: ((res) => {
              this.$store.commit('OPEN_BETFORM', true)
              this.oddSelectHighlight(windowEvent, betForm)

              if (res.SYSTEM_DATA.status != 'FAIL') {
                if(this.$store.getters.miniNormal==1){
                  this.showMiniBet(windowEvent);
                  if(this.$store.getters.sportMiniBet.toggle){
                    EventBus.$emit('expandMini')
                  }
                }
                if(!this.$store.getters.isBetCombo){
                  this.$store.commit('SPORT_MINIBET_BETAMOUNT', 0)
                  EventBus.$emit('resetKeyboard')
                }
                this.$store.commit('ODD_SELECTED', true)
                // this.$store.commit('SELECTED_BETTAB', true)
                this.$store.commit('BET_FORM', {
                  newBettingList: res.SYSTEM_DATA.betting,
                  oldBetData: betForm,
                })
                //multisingle & > 1 wager
                if(this.$store.getters.isBetCombo && this.$store.getters.betForm.length>1){ 
                  EventBus.$emit('clearAllBetComboAmount');
                  EventBus.$emit('resetKeyboard')
                }
                if (windowEvent) {
                  this.$store.commit('PARLAY_SELECTED', {
                    class: $(windowEvent.target).parents('.b_cen'),
                    eveid: this.event.eveid
                  })
                }
              } else if (res.SYSTEM_DATA.status == 'FAIL') {
                if(this.$store.getters.miniNormal==1){
                  this.showMiniBet(windowEvent);
                }
                
                if(!this.$store.getters.isBetCombo){
                  this.$store.commit('SPORT_MINIBET_BETAMOUNT', 0)
                }
                this.$store.commit('ODD_SELECTED', true)
                // this.$store.commit('SELECTED_BETTAB', true)
                this.$store.commit('BET_FORM', {
                  newBettingList: res.SYSTEM_DATA.betting,
                  oldBetData: betForm
                })
                if (windowEvent) {
                  this.$store.commit('PARLAY_SELECTED', {
                    class: $(windowEvent.target).parents('.b_rig'),
                    eveid: this.event.eveid
                  })
                }
              }
            }).bind(this)
          })
        }
        
      }
    },
    classNegative(val, oldVal) {
      this.isNegative = val < 0 ? true : false
    },
    diffOdds(val, oldVal) {
      this.isDiff = val != oldVal ? true : false
    },
    diffOddsUpDown(val, oldVal) {
      this.isUp = parseFloat(val) > parseFloat(oldVal) ? true : false
    },
    isDefinedOdds(val) {
      var isDefinedOdds = false
      if (typeof val.od != 'undefined') {
        if (typeof val.od[this.plyType] != 'undefined') {
          if(this.betType >= 59 && this.betType <= 73){
            if (typeof val.od[this.plyType][this.betType] != 'undefined') {
              if (typeof val.od[this.plyType][this.betType]['a']['odds' + this.team] != 'undefined') {
                isDefinedOdds = true
              }
            }
          }else{
            if (typeof val.od[this.plyType][this.betType] != 'undefined') {
              if (typeof val.od[this.plyType][this.betType]['odds' + this.team] != 'undefined') {
                isDefinedOdds = true
              }
            }
          }
        }
      }
      return isDefinedOdds
    },
  },
  beforeMount() {
    EventBus.$on(['refreshOdd'], ((params) => {
      if (params == false) {
        this.refreshOdd = false // change market, change page, change parlayEarlyDate
      } else {
        this.refreshOdd = true // change odd type, refresh button
      }
    }).bind(this))

    EventBus.$on(['diffOdd'], ((params) => {
      if (typeof this.event.all == 'undefined') {
        if (this.isDefinedOdds(this.event) && this.isDefinedOdds(params)) {
          this.diffOddsUpDown(params.od[this.plyType][this.betType]['odds' + this.team], this.event.od[this.plyType][this.betType]['odds' + this.team])
          this.diffOdds(params.od[this.plyType][this.betType]['odds' + this.team], this.event.od[this.plyType][this.betType]['odds' + this.team])
          this.$forceUpdate()
        }
      }
    }).bind(this))
  },
  
  mounted(){
    this.$store.getters.betForm.forEach(value => {
      var MID = value.uniqueId;
      $("[id="+MID+"]").closest('.c-bet-item').addClass('active')
    })
  },
  
  beforeDestroy() {
    EventBus.$off('diffOdd');
    EventBus.$off('refreshOdd')
  },
})



// WEBPACK FOOTER //
// ./resources/wob/vue/components/odd1x2.js